import React from 'react'
import { Link } from 'react-router-dom'
import SantanderLabel from 'components/VehicleDetails/SantanderLabel'
import Text from './AutopagoModalText'
import './style.scss'

export default ({ closeCallback=()=>{} }) => 
    <div className="AutopagoModal">
        <div className="AutopagoModal__content">

            <img 
                className="AutopagoModal__logo"
                src="/assets/img/wmautopago.svg" 
                alt="WebMotors - Autopago"  
                title="WebMotors - Autopago"
            />

            <Text title="O que é o Autopago?">
                <p>O Autopago é um serviço que garante ainda mais a segurança do comprador e vendedor. Realizamos:</p>
                <ul>
                    <li>
                        <span>Análise cadastral do comprador e vendedor;</span>
                    </li>
                    <li>
                        <span>O seu dinheiro fica seguro com a Webmotors até que a transação do veículo seja finalizada.</span>
                    </li>
                </ul>
            </Text> 

            <Text title="Quanto custa o Autopago?">
                <p>Para você, comprador, nada!<br />O Autopago é uma ferramenta de venda do veículo, por isso o comprador não recebe nenhuma cobrança!</p>
                <p>
                    <strong>Atenção!</strong> No Autopago, o valor do veículo deverá ser pago à vista.
                </p>
            </Text>
            
            <div className="AutopagoModal__santanderLabel AutopagoModal__santanderLabel--desktop">
                <SantanderLabel />
            </div>

        </div>
        <div className="AutopagoModal__content AutopagoModal__content--gray">

            <div className="AutopagoModal__close">
                <img 
                    onClick={()=> closeCallback() }
                    src="/assets/img/webp/icon-closed-send-proposal.webp" 
                    title="Fechar" 
                    alt="Fechar" 
                    width={24}
                    height={24}
                />
            </div>

            <Text title="O que deve ser feito antes de iniciar o Autopago?">
                <ol>
                    <li>
                        <span>Conversar com vendedor</span>
                    </li>
                    <li>
                        <span>Visitar o veículo</span>
                    </li>
                    <li>
                        <span>Ambos toparem fazer a transação via Autopago</span>
                    </li>
                </ol>
                <p>Agora, é só pedir para o vendedor te cadastrar e iniciar o Autopago ;)</p>
                <p>
                    Ficou alguma dúvida?{' '}
                    <a 
                        href="https://intercom.help/autopago-webmotors/pt-BR/" 
                        target="_blank"
                        rel="noreferrer"
                    >
                        Acesse nossa FAQ
                    </a>
                </p>
            </Text>


        </div>
        <div className="AutopagoModal__santanderLabel AutopagoModal__santanderLabel--mobile">
            <SantanderLabel />
        </div>
    </div>
